import { z } from 'zod';

// src/contracts/crypto.ts
var ENVELOPE_VERSION = 1;
var NONCE_BYTES = 24;
var TAG_BYTES = 16;
var KEY_BYTES = 32;
var SALT_BYTES = 16;
var ENVELOPE_OVERHEAD = 1 + NONCE_BYTES + TAG_BYTES;
var ATTACHMENT_CHUNK_BYTES = 1024 * 1024;
var KDF_ALG = "argon2id13";
var KDF_OPS = 3;
var KDF_MEM = 67108864;
var KDF_OUTPUT_BYTES = 64;
var KDF_BOUNDS = Object.freeze({
  minOps: 3,
  maxOps: 10,
  minMem: 64 * 1024 * 1024,
  maxMem: 256 * 1024 * 1024
});
var kdfParamsSchema = z.object({
  alg: z.literal(KDF_ALG),
  ops: z.number().int().min(KDF_BOUNDS.minOps).max(KDF_BOUNDS.maxOps),
  mem: z.number().int().min(KDF_BOUNDS.minMem).max(KDF_BOUNDS.maxMem)
});
function isSafeKdf(kdf) {
  return kdfParamsSchema.safeParse(kdf).success;
}
var DEFAULT_KDF = Object.freeze({ alg: KDF_ALG, ops: KDF_OPS, mem: KDF_MEM });
var LOGIN_KEY_CONTEXT = "ds1|login";
var RECOVERY_LOGIN_KEY_CONTEXT = "ds1|recovery-login";
var RECOVERY_KEY_PREFIX = "DS1-";
var RECOVERY_KEY_CHARS = 52;
var RECOVERY_KEY_GROUP = 4;
var AD = {
  doc: (docId) => `ds1|doc|${docId}`,
  awareness: (docId) => `ds1|awareness|${docId}`,
  masterKeyPassword: (userId) => `ds1|key|master|password|${userId}`,
  masterKeyRecovery: (userId) => `ds1|key|master|recovery|${userId}`,
  notebookKey: (notebookId) => `ds1|key|notebook|${notebookId}`,
  notebookKeyServer: (notebookId) => `ds1|key|notebook-server|${notebookId}`,
  noteKey: (noteId) => `ds1|key|note|${noteId}`,
  attachmentChunk: (attachmentId, index, last) => `ds1|att|${attachmentId}|${index}|${last ? 1 : 0}`,
  /** Secret half of the account key pair under the masterKey (crypto.md §10, D-54). */
  accountBoxKey: (userId) => `ds1|key|account-box|${userId}`,
  /** notebookKey / noteKey of `version` ≥ 2 under its parent key (version 1 keeps the plain ad). */
  notebookKeyVersion: (notebookId, version) => version <= 1 ? `ds1|key|notebook|${notebookId}` : `ds1|key|notebook|${notebookId}|${version}`,
  noteKeyVersion: (noteId, version) => version <= 1 ? `ds1|key|note|${noteId}` : `ds1|key|note|${noteId}|${version}`,
  /** spaceKey of a shared space under the owner's masterKey (crypto.md §11.1, D-62). */
  spaceKey: (spaceId, version) => version <= 1 ? `ds1|key|space|${spaceId}` : `ds1|key|space|${spaceId}|${version}`,
  /** notebookKey (of `version`) of a shared space's notebook under the spaceKey (§11.1). */
  spaceNotebookKey: (spaceId, notebookId, version) => `ds1|key|space-notebook|${spaceId}|${notebookId}|${version}`,
  /** Key of `version - 1` wrapped by the key of `version` (rotation chain). */
  previousKey: (kind, targetId, version) => `ds1|key|prev|${kind}|${targetId}|${version}`,
  /** A notebook/note key wrapped for another account (owner → member). */
  memberKey: (kind, targetId, version, fromUserId, toUserId) => `ds1|key|member|${kind}|${targetId}|${version}|${fromUserId}|${toUserId}`
};
var BOX_PUBLIC_KEY_BYTES = 32;
var BOX_SECRET_KEY_BYTES = 32;
var MEMBER_WRAP_CONTEXT = "ds1|member-wrap";
var SAFETY_CODE_CONTEXT = "ds1|safety-code";
var SAFETY_CODE_GROUPS = 6;
var SERVER_KEY_ENV = "DS_KMS_KEY";
var SHARE_LINK_KEY_PARAM = "k";

export { AD, ATTACHMENT_CHUNK_BYTES, BOX_PUBLIC_KEY_BYTES, BOX_SECRET_KEY_BYTES, DEFAULT_KDF, ENVELOPE_OVERHEAD, ENVELOPE_VERSION, KDF_ALG, KDF_BOUNDS, KDF_MEM, KDF_OPS, KDF_OUTPUT_BYTES, KEY_BYTES, LOGIN_KEY_CONTEXT, MEMBER_WRAP_CONTEXT, NONCE_BYTES, RECOVERY_KEY_CHARS, RECOVERY_KEY_GROUP, RECOVERY_KEY_PREFIX, RECOVERY_LOGIN_KEY_CONTEXT, SAFETY_CODE_CONTEXT, SAFETY_CODE_GROUPS, SALT_BYTES, SERVER_KEY_ENV, SHARE_LINK_KEY_PARAM, TAG_BYTES, isSafeKdf, kdfParamsSchema };
//# sourceMappingURL=chunk-SA27ENP5.js.map
//# sourceMappingURL=chunk-SA27ENP5.js.map